export const MapControls = () => {
  return <div></div>;
};
